import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from './globals';
import { CentralMetadata, MetadataValues } from 'app/models/central-metadata';
import { map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class CentralMetadataService {

    constructor(private http: HttpClient, private globals: Globals) {
    }

    getForm() {
        return this.http.get<CentralMetadata[]>(`${this.globals.api_base_url}/central_metadata`).pipe(map((c) => {
            let form = { components: [], central_metadata: c };
            c.forEach(m => {
                form.components.push(m.schema);
            });
            return form;
        }));;
    }

    fieldValues(key: string) {
        return this.http.get<MetadataValues>(`${this.globals.api_base_url}/central_metadata/values/${key}`).pipe(map((v) => {
            if (v.date_range) {
                if (v.date_range.startDate) {
                    v.date_range.startDate = new Date(v.date_range.startDate);
                }
                if (v.date_range.endDate) {
                    v.date_range.endDate = new Date(v.date_range.endDate);
                }
            }

            return v;
        }));
    }

    putForm(formSchema: any) {
        let components = formSchema.components;
        let centralMetadata: CentralMetadata[] = [];
        components.forEach(cmp => {
            centralMetadata.push({
                name: cmp.label || cmp.title,
                key: cmp.key,
                type: cmp.type,
                schema: JSON.stringify(cmp)
            });
        });
        return this.http.put<CentralMetadata[]>(`${this.globals.api_base_url}/central_metadata`, centralMetadata).pipe(map((c) => {
            let form = { components: [] };
            c.forEach(m => {
                form.components.push(m.schema);
            });

            return form;
        }));
    }

}